export function overrideHistoryBack() {
  const originalBack = history.back.bind(history);
  const originalGo = history.go.bind(history);
  history.back = function () {
    window.dispatchEvent(new CustomEvent('go-back'));
    originalBack();
  };
  history.go = function (delta: number) {
    if (delta === -1) {
      window.dispatchEvent(new CustomEvent('go-back'));
    }
    originalGo(delta);
  };
}
